import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import BookCardsList from '@/components/ui/book-cards-list/BookCardsList';
import Alphabet from '@/components/ui/alphabet/Alphabet';
import AdvancedSearchBar from '@/components/ui/advanced-search-bar/AdvancedSearchBar';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface ILibraryProps {
  books: IBookPage;
}

const Library: FC<ILibraryProps> = ({ books }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  const currentPage = books.page;

  //Seo block
  const SEO_TITLE = `Электронная библиотека книг фентези и фантастики Fantasy Worlds${currentPage > 1 ? `. Cтраница ${currentPage}.` : ''}`;
  const SEO_DESCRIPTION = `🕮 Электронная библиотека книг фентези и фантастики 📚 — Fantasy Worlds. ▶ Вы можете скачать бесплатно или читать онлайн самые лучшие электронные книги в форматах pdf, epub, fb2, txt.${
    currentPage > 1 ? ` Cтраница ${currentPage}.` : ''
  }`;
  const SEO_CANONICAL = '/lib';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Alphabet baseUrl="/lib/letter/" />
      <AdvancedSearchBar />
      <Breadcrumbs firstPageName="Библиотека" />
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/`} />
      <SectionTitle name="Библиотека" />
      <BookCardsList books={books.data} />
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/`} />
    </Layout>
  );
};

export default Library;
